"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduledEmailRecipientDisplayName = exports.getScheduledEmailRecipientEmail = exports.getScheduledEmailRecipientUniqueIdentifier = void 0;
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var interfaces_1 = require("../interfaces");
exports.getScheduledEmailRecipientUniqueIdentifier = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? recipient.user.login : recipient.email;
};
exports.getScheduledEmailRecipientEmail = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? recipient.user.email : recipient.email;
};
exports.getScheduledEmailRecipientDisplayName = function (recipient) {
    return interfaces_1.isScheduleEmailExistingRecipient(recipient) ? sdk_backend_spi_1.userFullName(recipient.user) : recipient.email;
};
//# sourceMappingURL=scheduledMailRecipients.js.map